import get from 'lodash/get';
import { ApiPrefix, ApiV1Base, ApiPrefixV1, statusCheck, getCookie, json } from 'util/icwUtility';
import fetch from 'cross-fetch';
import { ProductTestingTypes } from './types';

//-------------------------------------------------
// GET_COUNTRIES_LIST
export function getCountriesListLoading() {
  return { type: ProductTestingTypes.GET_COUNTRIES_LIST.LOADING };
}

export function getCountriesListSuccess(data) {
  return { type: ProductTestingTypes.GET_COUNTRIES_LIST.SUCCESS, payload: data };
}

export function getCountriesListError(error) {
  return { type: ProductTestingTypes.GET_COUNTRIES_LIST.ERROR, payload: error };
}

export function getCountriesList(cb) {
  return (dispatch) => {
    dispatch(getCountriesListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/areas/countries`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const countriesList = get(res, 'data', []);
        dispatch(getCountriesListSuccess(countriesList));
        if (cb) cb();
      })
      .catch((err) => {
        dispatch(getCountriesListError(typeof err === 'object' ? err.message : err));
      });
  };
}

// GET_JOB_LIST
export function getJobListLoading() {
  return { type: ProductTestingTypes.GET_JOB_LIST.LOADING };
}

export function getJobListSuccess(data, total) {
  return { type: ProductTestingTypes.GET_JOB_LIST.SUCCESS, payload: data, total };
}

export function getJobListError(error) {
  return { type: ProductTestingTypes.GET_JOB_LIST.ERROR, payload: error };
}

export function getJobList(filter, cb) {
  return (dispatch) => {
    dispatch(getJobListLoading());
    const { page, size, ...other } = filter;
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/search?pageNo=${page}&pageSize=${size}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(other),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const jobList = get(res, 'data.list', []);
        const jobListTotal = get(res, 'data.totalNo', 0);
        dispatch(getJobListSuccess(jobList, jobListTotal));
        if (cb) cb();
      })
      .catch((err) => {
        dispatch(getJobListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_JOB_DETAIL
export function getJobDetailLoading() {
  return { type: ProductTestingTypes.GET_JOB_DETAIL.LOADING };
}

export function getJobDetailSuccess(data) {
  return { type: ProductTestingTypes.GET_JOB_DETAIL.SUCCESS, payload: data };
}

export function getJobDetailError(error) {
  return { type: ProductTestingTypes.GET_JOB_DETAIL.ERROR, payload: error };
}

export function getJobDetail(jobId, cb) {
  return (dispatch) => {
    dispatch(getJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefixV1}/micro/product-testings/${jobId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const jobDetail = get(res, 'data', []);
        dispatch(getJobDetailSuccess(jobDetail));
        if (cb) cb();
      })
      .catch((err) => {
        dispatch(getJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_QUOTE_LIST_JOB_DETAIL
export function getQuoteListJobDetailLoading() {
  return { type: ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.LOADING };
}

export function getQuoteListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getQuoteListJobDetailError(error) {
  return { type: ProductTestingTypes.GET_QUOTE_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getQuoteListJobDetail(jobId, cb) {
  return (dispatch) => {
    dispatch(getQuoteListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/quotes`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const quoteListJobDetail = get(res, 'data', {});
        dispatch(getQuoteListJobDetailSuccess(quoteListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getQuoteListJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_QUOTE_DETAIL_JOB_DETAIL
export function getQuoteDetailJobDetailLoading() {
  return { type: ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.LOADING };
}

export function getQuoteDetailJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.SUCCESS, payload: data };
}

export function getQuoteDetailJobDetailError(error) {
  return { type: ProductTestingTypes.GET_QUOTE_DETAIL_JOB_DETAIL.ERROR, payload: error };
}

export function getQuoteDetailJobDetail(jobId, quoteId, cb) {
  return (dispatch) => {
    dispatch(getQuoteDetailJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/quotes/${quoteId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const quoteDetailJobDetail = get(res, 'data') || {};
        dispatch(getQuoteDetailJobDetailSuccess(quoteDetailJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getQuoteDetailJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_REPORT_LIST_JOB_DETAIL
export function getReportListJobDetailLoading() {
  return { type: ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.LOADING };
}

export function getReportListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getReportListJobDetailError(error) {
  return { type: ProductTestingTypes.GET_REPORT_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getReportListJobDetail(jobId, cb) {
  return (dispatch) => {
    dispatch(getReportListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportListJobDetail = get(res, 'data', {});
        dispatch(getReportListJobDetailSuccess(reportListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getReportListJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_REPORT_DETAIL_JOB_DETAIL
export function getReportDetailJobDetailLoading() {
  return { type: ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.LOADING };
}

export function getReportDetailJobDetailSuccess(data, cb) {
  if (cb) cb(data);
  return { type: ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.SUCCESS, payload: data };
}

export function getReportDetailJobDetailError(error) {
  return { type: ProductTestingTypes.GET_REPORT_DETAIL_JOB_DETAIL.ERROR, payload: error };
}

export function getReportDetailJobDetail(jobId, reportId, cb) {
  return (dispatch) => {
    dispatch(getReportDetailJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports/${reportId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportDetailJobDetail = get(res, 'data[0]') || {};
        dispatch(getReportDetailJobDetailSuccess(reportDetailJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getReportDetailJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_FAILURE_RECORD_LIST_JOB_DETAIL
export function getFailureRecordListJobDetailLoading() {
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.LOADING };
}

export function getFailureRecordListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getFailureRecordListJobDetailError(error) {
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getFailureRecordListJobDetail(jobId, filter, cb) {
  return (dispatch) => {
    dispatch(getFailureRecordListJobDetailLoading());
    const { page, size } = filter;
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/failureRecords?pageNo=${page}&pageSize=${size}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const failureRecordListJobDetail = get(res, 'data', {});
        dispatch(getFailureRecordListJobDetailSuccess(failureRecordListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getFailureRecordListJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_FAILURE_RECORD_DETAIL_JOB_DETAIL
export function getFailureRecordDetailJobDetailLoading() {
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.LOADING };
}

export function getFailureRecordDetailJobDetailSuccess(data, cb) {
  if (cb) cb(data);
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.SUCCESS, payload: data };
}

export function getFailureRecordDetailJobDetailError(error) {
  return { type: ProductTestingTypes.GET_FAILURE_RECORD_DETAIL_JOB_DETAIL.ERROR, payload: error };
}

export function getFailureRecordDetailJobDetail(jobId, failureRecordId, cb) {
  return (dispatch) => {
    dispatch(getFailureRecordDetailJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/failureRecords/${failureRecordId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const failureRecordDetailJobDetail = get(res, 'data') || {};
        dispatch(getFailureRecordDetailJobDetailSuccess(failureRecordDetailJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getFailureRecordDetailJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_ATTACHMENT_LIST_JOB_DETAIL
export function getAttachmentLJobDetailListLoading() {
  return { type: ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.LOADING };
}

export function getAttachmentJobDetailListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getAttachmentJobDetailListError(error) {
  return { type: ProductTestingTypes.GET_ATTACHMENT_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getAttachmentJobDetailList(jobId, cb) {
  return (dispatch) => {
    dispatch(getAttachmentLJobDetailListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/attachments`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const attachmentsJobDetail = get(res, 'data', {});
        dispatch(getAttachmentJobDetailListSuccess(attachmentsJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getAttachmentJobDetailListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_INVOICE_JOB_DETAIL
export function getInvoiceLJobDetailLoading() {
  return { type: ProductTestingTypes.GET_INVOICE_JOB_DETAIL.LOADING };
}

export function getInvoiceJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_INVOICE_JOB_DETAIL.SUCCESS, payload: data };
}

export function getInvoiceJobDetailError(error) {
  return { type: ProductTestingTypes.GET_INVOICE_JOB_DETAIL.ERROR, payload: error };
}

export function getInvoiceJobDetail(jobId, invoiceId, cb) {
  return (dispatch) => {
    dispatch(getInvoiceLJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/invoices/${invoiceId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const invoiceJobDetail = get(res, 'data', {});
        dispatch(getInvoiceJobDetailSuccess(invoiceJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getInvoiceJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_INVOICE_LIST_JOB_DETAIL
export function getInvoiceLJobDetailListLoading() {
  return { type: ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.LOADING };
}

export function getInvoiceJobDetailListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getInvoiceJobDetailListError(error) {
  return { type: ProductTestingTypes.GET_INVOICE_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getInvoiceJobDetailList(jobId, cb) {
  return (dispatch) => {
    dispatch(getInvoiceLJobDetailListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/invoices`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const invoicesJobDetail = get(res, 'data', {});
        dispatch(getInvoiceJobDetailListSuccess(invoicesJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getInvoiceJobDetailListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_LOG_LIST_JOB_DETAIL
export function getLogListJobDetailLoading() {
  return { type: ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.LOADING };
}

export function getLogListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getLogListJobDetailError(error) {
  return { type: ProductTestingTypes.GET_LOG_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getLogListJobDetail(jobId, cb) {
  return (dispatch) => {
    dispatch(getLogListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/logs`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const logListJobDetail = get(res, 'data', []);
        dispatch(getLogListJobDetailSuccess(logListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getLogListJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_TAG_LIST_JOB_DETAIL
export function getTagListJobDetailLoading() {
  return { type: ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.LOADING };
}

export function getTagListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function getTagListJobDetailError(error) {
  return { type: ProductTestingTypes.GET_TAG_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function getTagListJobDetail(jobId, cb) {
  return (dispatch) => {
    dispatch(getTagListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/tags`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const tagListJobDetail = get(res, 'data', []);
        dispatch(getTagListJobDetailSuccess(tagListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(getTagListJobDetailError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_PRODUCT_LIST
export function getProductListLoading() {
  return { type: ProductTestingTypes.GET_PRODUCT_LIST.LOADING };
}

export function getProductListSuccess(data, total, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_PRODUCT_LIST.SUCCESS, payload: data, total };
}

export function getProductListError(error) {
  return { type: ProductTestingTypes.GET_PRODUCT_LIST.ERROR, payload: error };
}

export function getProductList(filter = {}, cb) {
  return (dispatch) => {
    dispatch(getProductListLoading());
    const pageNo = get(filter, 'page', 1);
    const keyword = get(filter, 'keyword', '');
    const url = `${ApiV1Base}${ApiPrefix}/product/list`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      // API starts with pageNo = 0
      body: JSON.stringify({ pageNo: pageNo - 1, keyword }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const productList = get(res, 'list') || [];
        const productListTotal = get(res, 'total', 0);
        dispatch(getProductListSuccess(productList, productListTotal, cb));
      })
      .catch((err) => {
        dispatch(getProductListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_SUPPLIER_LIST
export function getSupplierListLoading() {
  return { type: ProductTestingTypes.GET_SUPPLIER_LIST.LOADING };
}

export function getSupplierListSuccess(data, total, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_SUPPLIER_LIST.SUCCESS, payload: data, total };
}

export function getSupplierListError(error) {
  return { type: ProductTestingTypes.GET_SUPPLIER_LIST.ERROR, payload: error };
}

export function getSupplierList(filter = {}, cb) {
  return (dispatch) => {
    dispatch(getSupplierListLoading());
    const pageNo = get(filter, 'page', 1);
    const keyword = get(filter, 'keyword', '');
    const url = `${ApiV1Base}${ApiPrefix}/suppliers/list`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      // API starts with pageNo = 1
      body: JSON.stringify({ pageNo, keyword }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const supplierList = get(res, 'suppliers') || [];
        const supplierListTotal = get(res, 'totalNo', 0);
        dispatch(getSupplierListSuccess(supplierList, supplierListTotal, cb));
      })
      .catch((err) => {
        dispatch(getSupplierListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_TAG_LIST
export function getTagListLoading() {
  return { type: ProductTestingTypes.GET_TAG_LIST.LOADING };
}

export function getTagListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_TAG_LIST.SUCCESS, payload: data };
}

export function getTagListError(error) {
  return { type: ProductTestingTypes.GET_TAG_LIST.ERROR, payload: error };
}

export function getTagList(cb, { type = 'productTesting', name = '' } = {}) {
  return (dispatch) => {
    dispatch(getTagListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/tags?type=${type}&name=${name}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(getTagListSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(getTagListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_LAB_LIST
export function getLabListLoading() {
  return { type: ProductTestingTypes.GET_LAB_LIST.LOADING };
}

export function getLabListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_LAB_LIST.SUCCESS, payload: data };
}

export function getLabListError(error) {
  return { type: ProductTestingTypes.GET_LAB_LIST.ERROR, payload: error };
}

export function getLabList(cb) {
  return (dispatch) => {
    dispatch(getLabListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/serviceProviders/lists`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        type: 'productTesting',
        category: 'common',
      }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(getLabListSuccess(get(res, 'data', []), cb));
      })
      .catch((err) => {
        dispatch(getLabListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_LAB_OPTIONAL_LIST
export function getLabOptionalListLoading() {
  return { type: ProductTestingTypes.GET_LAB_OPTIONAL_LIST.LOADING };
}

export function getLabOptionalListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_LAB_OPTIONAL_LIST.SUCCESS, payload: data };
}

export function getLabOptionalListError(error) {
  return { type: ProductTestingTypes.GET_LAB_OPTIONAL_LIST.ERROR, payload: error };
}

export function getLabOptionalList(cb) {
  return (dispatch) => {
    dispatch(getLabOptionalListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/serviceProviders/lists`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        type: 'productTesting',
        category: 'optional',
      }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(getLabOptionalListSuccess(get(res, 'data', []), cb));
      })
      .catch((err) => {
        dispatch(getLabOptionalListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_REPORT_LAB_LIST
export function getReportLabListLoading() {
  return { type: ProductTestingTypes.GET_REPORT_LAB_LIST.LOADING };
}

export function getReportLabListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_REPORT_LAB_LIST.SUCCESS, payload: data };
}

export function getReportLabListError(error) {
  return { type: ProductTestingTypes.GET_REPORT_LAB_LIST.ERROR, payload: error };
}

export function getReportLabList(cb) {
  return (dispatch) => {
    dispatch(getReportLabListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/reports/labs`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportLabList = get(res, 'data') || [];
        dispatch(getReportLabListSuccess(reportLabList, cb));
      })
      .catch((err) => {
        dispatch(getReportLabListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_REPORT_CITATION_LIST
export function getReportCitationListLoading() {
  return { type: ProductTestingTypes.GET_REPORT_CITATION_LIST.LOADING };
}

export function getReportCitationListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_REPORT_CITATION_LIST.SUCCESS, payload: data };
}

export function getReportCitationListError(error) {
  return { type: ProductTestingTypes.GET_REPORT_CITATION_LIST.ERROR, payload: error };
}

export function getReportCitationList(cb) {
  return (dispatch) => {
    dispatch(getReportCitationListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/reports/citations`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportCitationList = get(res, 'data') || [];
        dispatch(getReportCitationListSuccess(reportCitationList, cb));
      })
      .catch((err) => {
        dispatch(getReportCitationListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_REPORT_TEST_ITEM_LIST
export function getReportTestItemListLoading() {
  return { type: ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.LOADING };
}

export function getReportTestItemListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.SUCCESS, payload: data };
}

export function getReportTestItemListError(error) {
  return { type: ProductTestingTypes.GET_REPORT_TEST_ITEM_LIST.ERROR, payload: error };
}

export function getReportTestItemList(cb) {
  return (dispatch) => {
    dispatch(getReportTestItemListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/reports/testItems`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportTestItemList = get(res, 'data') || [];
        dispatch(getReportTestItemListSuccess(reportTestItemList, cb));
      })
      .catch((err) => {
        dispatch(getReportTestItemListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_SERVICE_PROVIDER
export function getServiceProviderLoading() {
  return { type: ProductTestingTypes.GET_SERVICE_PROVIDER.LOADING };
}

export function getServiceProviderSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_SERVICE_PROVIDER.SUCCESS, payload: data };
}

export function getServiceProviderError(error) {
  return { type: ProductTestingTypes.GET_SERVICE_PROVIDER.ERROR, payload: error };
}

export function getServiceProvider(cb) {
  return (dispatch) => {
    dispatch(getServiceProviderLoading());
    // const url = `${ApiPrefix}/productTestings/serviceProviders`;
    const url = `${ApiV1Base}${ApiPrefix}/serviceProviders/lists`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      // method: 'GET',
      method: 'POST',
      body: JSON.stringify({
        type: 'productTesting',
      }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const serviceProviders = get(res, 'data') || [];
        dispatch(getServiceProviderSuccess(serviceProviders, cb));
      })
      .catch((err) => {
        dispatch(getServiceProviderError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_ANALYTICS_DATA
export function getAnalyticsDataLoading() {
  return { type: ProductTestingTypes.GET_ANALYTICS_DATA.LOADING };
}

export function getAnalyticsDataSuccess(data) {
  return { type: ProductTestingTypes.GET_ANALYTICS_DATA.SUCCESS, payload: data };
}

export function getAnalyticsDataError(error) {
  return { type: ProductTestingTypes.GET_ANALYTICS_DATA.ERROR, payload: error };
}

export function getAnalyticsData(filter) {
  return (dispatch) => {
    dispatch(getAnalyticsDataLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/analytics`;
    let fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };

    if (filter) {
      fetchOption = { ...fetchOption, method: 'POST', body: JSON.stringify(filter) };
    }

    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const analyticsData = get(res, 'data') || {};
        dispatch(getAnalyticsDataSuccess(analyticsData));
      })
      .catch((err) => {
        dispatch(getAnalyticsDataError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// GET_QUOTE_TEST_ITEM_LIST
export function getQuoteTestItemListLoading() {
  return { type: ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.LOADING };
}

export function getQuoteTestItemListSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.SUCCESS, payload: data };
}

export function getQuoteTestItemListError(error) {
  return { type: ProductTestingTypes.GET_QUOTE_TEST_ITEM_LIST.ERROR, payload: error };
}

export function getQuoteTestItemList(cb) {
  return (dispatch) => {
    dispatch(getQuoteTestItemListLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/testItems`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const quoteTestItemList = get(res, 'data') || [];
        dispatch(getQuoteTestItemListSuccess(quoteTestItemList, cb));
      })
      .catch((err) => {
        dispatch(getQuoteTestItemListError(typeof err === 'object' ? err.message : err));
      });
  };
}

//-------------------------------------------------
// CREATE_JOB
export function createJobLoading() {
  return { type: ProductTestingTypes.CREATE_JOB.LOADING };
}

export function createJobSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.CREATE_JOB.SUCCESS, payload: data };
}

export function createJobError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.CREATE_JOB.ERROR, payload: error };
}

export function createJob(data, cb, cbError) {
  return (dispatch) => {
    dispatch(createJobLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(createJobSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(createJobError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DUPLICATE_JOB
export function duplicateJobLoading() {
  return { type: ProductTestingTypes.DUPLICATE_JOB.LOADING };
}

export function duplicateJobSuccess(data, cb) {
  if (cb) cb(data);
  return { type: ProductTestingTypes.DUPLICATE_JOB.SUCCESS, payload: data };
}

export function duplicateJobError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DUPLICATE_JOB.ERROR, payload: error };
}

export function duplicateJob(jobId, cb, cbError) {
  return (dispatch) => {
    dispatch(duplicateJobLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(duplicateJobSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(duplicateJobError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_JOB_DETAIL
export function updateJobDetailLoading() {
  return { type: ProductTestingTypes.UPDATE_JOB_DETAIL.LOADING };
}

export function updateJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_JOB_DETAIL.SUCCESS, payload: data };
}

export function updateJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_JOB_DETAIL.ERROR, payload: error };
}

export function updateJobDetail(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PATCH',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const jobDetailUpdated = get(res, 'data', {});
        dispatch(updateJobDetailSuccess(jobDetailUpdated, cb));
      })
      .catch((err) => {
        dispatch(updateJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_ADMIN_STATUS_JOB_DETAIL
export function updateAdminStatusJobDetailLoading() {
  return { type: ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.LOADING };
}

export function updateAdminStatusJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.SUCCESS, payload: data };
}

export function updateAdminStatusJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_ADMIN_STATUS_JOB_DETAIL.ERROR, payload: error };
}

export function updateAdminStatusJobDetail(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateAdminStatusJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/status`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
        adminToken: getCookie('adminToken'),
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const statusJobDetailUpdated = get(res, 'data.status', get(data, 'status'));
        dispatch(updateAdminStatusJobDetailSuccess(statusJobDetailUpdated, cb));
      })
      .catch((err) => {
        dispatch(
          updateAdminStatusJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

//-------------------------------------------------
// UPDATE_LINKAGE
export function updateLinkageLoading() {
  return { type: ProductTestingTypes.UPDATE_LINKAGE.LOADING };
}

export function updateLinkageSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_LINKAGE.SUCCESS, payload: data };
}

export function updateLinkageError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_LINKAGE.ERROR, payload: error };
}

export function updateLinkage(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateLinkageLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/linkage`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const jobDetailUpdated = get(res, 'data', []);
        dispatch(updateLinkageSuccess(jobDetailUpdated, cb));
      })
      .catch((err) => {
        dispatch(updateLinkageError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// CREATE_QUOTE
export function createQuoteLoading() {
  return { type: ProductTestingTypes.CREATE_QUOTE.LOADING };
}

export function createQuoteSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.CREATE_QUOTE.SUCCESS, payload: data };
}

export function createQuoteError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.CREATE_QUOTE.ERROR, payload: error };
}

export function createQuote(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(createQuoteLoading());

    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/quotes`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(createQuoteSuccess(res, cb));
        dispatch(updateAdminStatusJobDetail(jobId, { status: 'quoteAvailable' }));
      })
      .catch((err) => {
        dispatch(createQuoteError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_QUOTE
export function updateQuoteLoading() {
  return { type: ProductTestingTypes.UPDATE_REPORT.LOADING };
}

export function updateQuoteSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_REPORT.SUCCESS, payload: data };
}

export function updateQuoteError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_REPORT.ERROR, payload: error };
}

export function updateQuote(jobId, quoteId, isAcceptedType = false, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateQuoteLoading());
    const url = isAcceptedType
      ? `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/quotes/${quoteId}/accepted`
      : `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/quotes/${quoteId}`;
    let fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
    };

    if (!isAcceptedType) {
      fetchOption = { ...fetchOption, body: JSON.stringify(data) };
    }

    if (isAcceptedType) {
      dispatch(updateAdminStatusJobDetail(jobId, { status: 'waitingTesting' }));
    }

    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(updateQuoteSuccess(res, cb));
        if (!isAcceptedType) {
          dispatch(updateAdminStatusJobDetail(jobId, { status: 'quoteAvailable' }));
        }
      })
      .catch((err) => {
        dispatch(updateQuoteError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// CREATE_REPORT
export function createReportLoading() {
  return { type: ProductTestingTypes.CREATE_REPORT.LOADING };
}

export function createReportSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.CREATE_REPORT.SUCCESS, payload: data };
}

export function createReportError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.CREATE_REPORT.ERROR, payload: error };
}

export function createReport(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(createReportLoading());
    const url = `${ApiV1Base}${ApiPrefixV1}/micro/product-testings/${jobId}/reports`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(createReportSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(createReportError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_REPORT
export function updateReportLoading() {
  return { type: ProductTestingTypes.UPDATE_REPORT.LOADING };
}

export function updateReportSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_REPORT.SUCCESS, payload: data };
}

export function updateReportError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_REPORT.ERROR, payload: error };
}

export function updateReport(jobId, reportId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateReportLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports/${reportId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(updateReportSuccess(res, cb));
      })
      .catch((err) => {
        dispatch(updateReportError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_REPORT
export function deleteReportLoading() {
  return { type: ProductTestingTypes.DELETE_REPORT.LOADING };
}

export function deleteReportSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_REPORT.SUCCESS, payload: data };
}

export function deleteReportError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_REPORT.ERROR, payload: error };
}

export function deleteReport(jobId, reportId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteReportLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports/${reportId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(deleteReportSuccess(reportId, cb));
      })
      .catch((err) => {
        dispatch(deleteReportError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// CREATE_FAILURE_RECORD
export function createFailureRecordLoading() {
  return { type: ProductTestingTypes.CREATE_FAILURE_RECORD.LOADING };
}

export function createFailureRecordSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.CREATE_FAILURE_RECORD.SUCCESS, payload: data };
}

export function createFailureRecordError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.CREATE_FAILURE_RECORD.ERROR, payload: error };
}

export function createFailureRecord(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(createFailureRecordLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/failureRecords`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(createFailureRecordSuccess(get(res, 'data') || {}, cb));
      })
      .catch((err) => {
        dispatch(createFailureRecordError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_FAILURE_RECORD
export function updateFailureRecordLoading() {
  return { type: ProductTestingTypes.UPDATE_FAILURE_RECORD.LOADING };
}

export function updateFailureRecordSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_FAILURE_RECORD.SUCCESS, payload: data };
}

export function updateFailureRecordError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_FAILURE_RECORD.ERROR, payload: error };
}

export function updateFailureRecord(jobId, failureRecordId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateFailureRecordLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/failureRecords/${failureRecordId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(updateFailureRecordSuccess(get(res, 'data') || {}, cb));
      })
      .catch((err) => {
        dispatch(updateFailureRecordError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_FAILURE_RECORD
export function deleteFailureRecordLoading() {
  return { type: ProductTestingTypes.DELETE_FAILURE_RECORD.LOADING };
}

export function deleteFailureRecordSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_FAILURE_RECORD.SUCCESS, payload: data };
}

export function deleteFailureRecordError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_FAILURE_RECORD.ERROR, payload: error };
}

export function deleteFailureRecord(jobId, failureRecordId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteFailureRecordLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/failureRecords/${failureRecordId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(deleteFailureRecordSuccess(failureRecordId, cb));
      })
      .catch((err) => {
        dispatch(deleteFailureRecordError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// ADD_ATTACHMENT_JOB_DETAIL
export function addAttachmentJobDetailLoading() {
  return { type: ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.LOADING };
}

export function addAttachmentJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.SUCCESS, payload: data };
}

export function addAttachmentJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.ADD_ATTACHMENT_JOB_DETAIL.ERROR, payload: error };
}

export function addAttachmentJobDetail(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(addAttachmentJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/attachments`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const data = get(res, 'data', {});
        dispatch(addAttachmentJobDetailSuccess(data, cb));
      })
      .catch((err) => {
        dispatch(addAttachmentJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_ATTACHMENT_JOB_DETAIL
export function deleteAttachmentJobDetailLoading() {
  return { type: ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.LOADING };
}

export function deleteAttachmentJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.SUCCESS, payload: data };
}

export function deleteAttachmentJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_ATTACHMENT_JOB_DETAIL.ERROR, payload: error };
}

export function deleteAttachmentJobDetail(jobId, attachmentId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteAttachmentJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/attachments/${attachmentId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(deleteAttachmentJobDetailSuccess(attachmentId, cb));
      })
      .catch((err) => {
        dispatch(
          deleteAttachmentJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

//-------------------------------------------------
// ADD_INVOICE_JOB_DETAIL
export function addInvoiceJobDetailLoading() {
  return { type: ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.LOADING };
}

export function addInvoiceJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.SUCCESS, payload: data };
}

export function addInvoiceJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.ADD_INVOICE_JOB_DETAIL.ERROR, payload: error };
}

export function addInvoiceJobDetail(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(addInvoiceJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/invoices`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const newInvoiceList = get(res, 'data', {});
        dispatch(addInvoiceJobDetailSuccess(newInvoiceList, cb));
      })
      .catch((err) => {
        dispatch(addInvoiceJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// UPDATE_INVOICE_JOB_DETAIL
export function updateInvoiceJobDetailLoading() {
  return { type: ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.LOADING };
}

export function updateInvoiceJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.SUCCESS, payload: data };
}

export function updateInvoiceJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.UPDATE_INVOICE_JOB_DETAIL.ERROR, payload: error };
}

export function updateInvoiceJobDetail(jobId, invoiceId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(updateInvoiceJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/invoices/${invoiceId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'PUT',
      body: JSON.stringify(data),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const updatedInvoiceList = get(res, 'data', {});
        dispatch(updateInvoiceJobDetailSuccess(updatedInvoiceList, cb));
      })
      .catch((err) => {
        dispatch(updateInvoiceJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_INVOICE_JOB_DETAIL
export function deleteInvoiceJobDetailLoading() {
  return { type: ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.LOADING };
}

export function deleteInvoiceJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.SUCCESS, payload: data };
}

export function deleteInvoiceJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_INVOICE_JOB_DETAIL.ERROR, payload: error };
}

export function deleteInvoiceJobDetail(jobId, invoiceId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteInvoiceJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/invoices/${invoiceId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        dispatch(getInvoiceJobDetailList(jobId));
        if (cb) cb();
      })
      .catch((err) => {
        dispatch(deleteInvoiceJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// ADD_TAG_JOB_DETAIL
export function addTagJobDetailLoading() {
  return { type: ProductTestingTypes.ADD_TAG_JOB_DETAIL.LOADING };
}

export function addTagJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.ADD_TAG_JOB_DETAIL.SUCCESS, payload: data };
}

export function addTagJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.ADD_TAG_JOB_DETAIL.ERROR, payload: error };
}

export function addTagJobDetail(jobId, data, cb, cbError) {
  return (dispatch) => {
    dispatch(addTagJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/tag`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ name: data }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const tagListJobDetail = get(res, 'data', []);
        dispatch(addTagJobDetailSuccess(tagListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(addTagJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_TAG_JOB_DETAIL
export function deleteTagJobDetailLoading() {
  return { type: ProductTestingTypes.DELETE_TAG_JOB_DETAIL.LOADING };
}

export function deleteTagJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_TAG_JOB_DETAIL.SUCCESS, payload: data };
}

export function deleteTagJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_TAG_JOB_DETAIL.ERROR, payload: error };
}

export function deleteTagJobDetail(jobId, tagId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteTagJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/tag/${tagId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const tagListJobDetail = get(res, 'data', []);
        dispatch(deleteTagJobDetailSuccess(tagListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(deleteTagJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DELETE_LAB_JOB_DETAIL
export function deleteLabJobDetailLoading() {
  return { type: ProductTestingTypes.DELETE_LAB_JOB_DETAIL.LOADING };
}

export function deleteLabJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DELETE_LAB_JOB_DETAIL.SUCCESS, payload: data };
}

export function deleteLabJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DELETE_LAB_JOB_DETAIL.ERROR, payload: error };
}

export function deleteLabJobDetail(jobId, labId, cb, cbError) {
  return (dispatch) => {
    dispatch(deleteLabJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/labs/${labId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const labListJobDetail = get(res, 'data', []);
        dispatch(deleteLabJobDetailSuccess(labListJobDetail, cb));
      })
      .catch((err) => {
        dispatch(deleteLabJobDetailError(typeof err === 'object' ? err.message : err, cbError));
      });
  };
}

//-------------------------------------------------
// DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL
export function downloadQuoteDocumentsJobDetailLoading() {
  return { type: ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.LOADING };
}

export function downloadQuoteDocumentsJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.SUCCESS, payload: data };
}

export function downloadQuoteDocumentsJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.ERROR, payload: error };
}

export function downloadQuoteDocumentsJobDetail(jobId, quoteId, cb, cbError) {
  return (dispatch) => {
    dispatch(downloadQuoteDocumentsJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/quotes/${quoteId}/attachment`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const quoteZipFile = get(res, 'data', {});
        dispatch(downloadQuoteDocumentsJobDetailSuccess(quoteZipFile, cb));
      })
      .catch((err) => {
        dispatch(
          downloadQuoteDocumentsJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

export function downloadQuoteDocumentsJobDetailReset() {
  return { type: ProductTestingTypes.DOWNLOAD_QUOTE_DOCUMENTS_JOB_DETAIL.RESET };
}

//-------------------------------------------------
// DOWNLOAD_REPORT_LIST_JOB_DETAIL
export function downloadReportListJobDetailLoading() {
  return { type: ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.LOADING };
}

export function downloadReportListJobDetailSuccess(data, cb) {
  if (cb) cb();
  return { type: ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function downloadReportListJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function downloadReportListJobDetail(jobId, params, cb, cbError) {
  return (dispatch) => {
    dispatch(downloadReportListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports/download`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(params),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportZipFile = get(res, 'data', {});
        dispatch(downloadReportListJobDetailSuccess(reportZipFile, cb));
      })
      .catch((err) => {
        dispatch(
          downloadReportListJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

export function downloadReportListJobDetailForPublic(jobId, params, cb, cbError) {
  return (dispatch) => {
    dispatch(downloadReportListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/reports/public/download`;
    const fetchOption = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(params),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const reportZipFile = get(res, 'data', {});
        dispatch(downloadReportListJobDetailSuccess(reportZipFile, cb));
      })
      .catch((err) => {
        dispatch(
          downloadReportListJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

export function downloadReportListJobDetailReset() {
  return { type: ProductTestingTypes.DOWNLOAD_REPORT_LIST_JOB_DETAIL.RESET };
}

//-------------------------------------------------
// DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL
export function downloadAttachmentListJobDetailLoading() {
  return { type: ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.LOADING };
}

export function downloadAttachmentListJobDetailSuccess(data, cb) {
  if (cb) cb(data);
  return { type: ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function downloadAttachmentListJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function downloadAttachmentListJobDetail(jobId, cb, cbError) {
  return (dispatch) => {
    dispatch(downloadAttachmentListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/attachments/download`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const attachmentZipFile = get(res, 'data', {});
        dispatch(downloadAttachmentListJobDetailSuccess(attachmentZipFile, cb));
      })
      .catch((err) => {
        dispatch(
          downloadAttachmentListJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

export function downloadAttachmentListJobDetailReset() {
  return { type: ProductTestingTypes.DOWNLOAD_ATTACHMENT_LIST_JOB_DETAIL.RESET };
}

//-------------------------------------------------
// DOWNLOAD_INVOICE_LIST_JOB_DETAIL
export function downloadInvoiceListJobDetailLoading() {
  return { type: ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.LOADING };
}

export function downloadInvoiceListJobDetailSuccess(data, cb) {
  if (cb) cb(data);
  return { type: ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.SUCCESS, payload: data };
}

export function downloadInvoiceListJobDetailError(error, cbError) {
  if (cbError) cbError();
  return { type: ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.ERROR, payload: error };
}

export function downloadInvoiceListJobDetail(jobId, invoiceId, cb, cbError) {
  return (dispatch) => {
    dispatch(downloadInvoiceListJobDetailLoading());
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${jobId}/invoices/${invoiceId}/download`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const invoiceZipFile = get(res, 'data', {});
        dispatch(downloadInvoiceListJobDetailSuccess(invoiceZipFile, cb));
      })
      .catch((err) => {
        dispatch(
          downloadInvoiceListJobDetailError(typeof err === 'object' ? err.message : err, cbError)
        );
      });
  };
}

export function downloadInvoiceListJobDetailReset() {
  return { type: ProductTestingTypes.DOWNLOAD_INVOICE_LIST_JOB_DETAIL.RESET };
}

//-------------------------------------------------
// DOWNLOAD_FACTORY_AUDIT
export function downloadProductTesting(jobIds, cb) {
  return () => {
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/lists/excel`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({ jobIds }),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const attachmentFile = get(res, 'data', []);

        if (cb) cb(attachmentFile);
      })
      .catch((err) => {});
  };
}

//-------------------------------------------------
// DELETE_QUOTE_ITEM
export function deleteQuoteIem(jobId, quoteId, cb) {
  return (dispatch) => {
    const url = `${ApiV1Base}${ApiPrefix}/admin/productTestings/${jobId}/quotes/${quoteId}`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'DELETE',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then(() => {
        dispatch(getQuoteListJobDetail(jobId, cb));
      })
      .catch((err) => {});
  };
}

//-------------------------------------------------
// SHARE_REPORT
export function shareReportEmail(productId, formData, cb) {
  return () => {
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${productId}/reports/share/email`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(formData),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then(() => {
        if (cb) cb();
      })
      .catch((err) => {});
  };
}

export function shareReport(productId, formData, cb) {
  return () => {
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/${productId}/reports/share`;
    const fetchOption = {
      headers: {
        Authorization: getCookie('token'),
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(formData),
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const data = get(res, 'data', []);
        if (cb) cb(data);
      })
      .catch((err) => {});
  };
}

export function getShareReportLoading() {
  return { type: ProductTestingTypes.GET_SHARE_REPORT.LOADING };
}

export function getShareReportSuccess(data) {
  return { type: ProductTestingTypes.GET_SHARE_REPORT.SUCCESS, payload: data };
}

export function getShareReportError(error) {
  return { type: ProductTestingTypes.GET_SHARE_REPORT.ERROR, payload: error };
}

export function getShareReport(token) {
  return (dispatch) => {
    const url = `${ApiV1Base}${ApiPrefix}/productTestings/reports/share?token=${token}`;
    const fetchOption = {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'GET',
    };
    return fetch(url, fetchOption)
      .then(statusCheck)
      .then(json)
      .then((res) => {
        const data = get(res, 'data', []);
        dispatch(getShareReportSuccess(data));
      })
      .catch((err) => {
        dispatch(getShareReportError(typeof err === 'object' ? err.message : err));
      });
  };
}
